import { formatDate } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { InfoCardComponent } from 'src/app/components/shared/info-card/info-card.component';
import { BlockedSeatsService } from 'src/app/services/blocked-seats.service';
import { CreateEventService } from 'src/app/services/create-event.service';
import { EventosService } from 'src/app/services/eventos.service';
import { OrdersEventService } from 'src/app/services/orders-event.service';

@Component({
  selector: 'app-map-seats-create',
  templateUrl: './map-seats-create.component.html',
  styleUrls: ['./map-seats-create.component.scss']
})
export class MapSeatsCreateComponent {

  @Input() idEvent!: any;
  @Input() sessions!: any;
  @Input() venue!: any;
  @Input() capacity!: any;
  @Input() map!: any;
  @Input() useMapVenue!: any;
  @Input() mapVersion!: any;
  @Output() changeTab: EventEmitter<any> = new EventEmitter<any>();
  business = JSON.parse(localStorage.getItem('business') || '{}');

  openedCreateMap: boolean = false;
  editCreateMap: boolean = true;
  loading: boolean = true;
  max: number = 10000;
  external = true;
  showMap: boolean = false;

  // Asientos bloqueados/ocupados (edición de un evento existente con mapa de butacas)
  sessionsList: any[] = [];
  selectedSession: any = null;
  typeTicketsSession: boolean = false;
  blockedSeatsEvent: any[] = [];
  blockedSeats: any[] = [];
  loadingBlockedSeats: boolean = false;
  blockedSeatsLoaded: boolean = false;
  // Mientras se pinta el canvas del mapa (tras cargar los datos de la sesión).
  loadingMap: boolean = false;

  constructor(private eventService: EventosService, private dialog: MatDialog, private activatedRoute: ActivatedRoute,
    private createService: CreateEventService, private ordersEventService: OrdersEventService,
    private blockedSeatsService: BlockedSeatsService) { }

  ngOnInit(): void {
    let capacity = this.createService.getCapacity();
    if (capacity && capacity != null && capacity != undefined) {
      this.capacity = capacity;
    }
    this.map = this.mapVersion;

    let infoEvent = this.createService.getInfoEvent();
    if (infoEvent) {
      this.venue = infoEvent.values?.space;
      this.external = infoEvent.values?.external;
      this.useMapVenue = infoEvent.values?.use_map;

      // Solo usar el aforo del espacio si se usan entradas numeradas (mapa de butacas).
      // Para entradas sin numerar, el usuario debe poder indicar su propio aforo libremente.
      if (this.useMapVenue) {
        this.capacity = this.venue?.capacity ?? this.capacity;
      }

      // Guardar el capacity en el observable para que la validación funcione
      if (this.capacity != null && this.capacity != undefined) {
        this.createService.setCapacity(this.capacity);
      }

      this.map = this.venue?.current_version;
      if (this.venue && this.mapVersion && this.useMapVenue) {
        this.map = this.mapVersion;
        this.eventService.setActionMap({ open: true });
      } else {
        // Para entradas sin numerar no limitamos el aforo por la capacidad del espacio
        this.max = 100000;
      }

      // Sesiones ordenadas por fecha, para el selector de bloqueo por sesión
      this.sessionsList = [...(this.sessions || [])].sort((a: any, b: any) =>
        new Date(a.start_date).getTime() - new Date(b.start_date).getTime());
    }
    this.loading = false;
  }

  // Se llama al pulsar "Ver mapa"/"Ocultar": la carga de asientos bloqueados se
  // difiere hasta que el usuario realmente quiere ver el mapa (así el spinner es
  // visible siempre la primera vez, en vez de resolverse en segundo plano antes
  // de que el usuario llegue a pulsar el botón).
  toggleMap(): void {
    this.showMap = !this.showMap;
    if (this.showMap) {
      // El spinner debe verse desde el primer instante: primero mientras se
      // cargan los asientos bloqueados y después mientras se pinta el canvas.
      this.loadingMap = true;
      if (this.idEvent && this.useMapVenue && !this.blockedSeatsLoaded) {
        this.loadBlockedSeats();
      }
    }
  }

  // El mapa (app-create-map) avisa cuando termina de cargar los datos y pintar
  // el canvas para que podamos ocultar el spinner.
  onMapLoadingChange(loading: boolean): void {
    this.loadingMap = loading;
  }

  loadBlockedSeats(): void {
    this.loadingBlockedSeats = true;
    this.blockedSeatsService.getBlockedSeatsByEvent(this.idEvent).subscribe({
      next: (val) => {
        const blockedSeatsData: any[] = Array.isArray(val.data) ? val.data : (val.data?.blocked_seats ?? []);
        this.blockedSeatsEvent = blockedSeatsData;
        if (blockedSeatsData.length > 0) {
          const blockedSessions = [...new Set(this.blockedSeatsEvent.map((bs: any) => bs.id_session))];
          this.typeTicketsSession = blockedSessions.length > 1;
        }
        if (this.sessionsList.length > 0) {
          this.selectedSession = this.sessionsList[0].id;
        }
        this.updateBlockedSeatsForSelectedSession();
        this.blockedSeatsLoaded = true;
        this.loadingBlockedSeats = false;
      },
      error: () => {
        this.loadingBlockedSeats = false;
      }
    });
  }

  updateBlockedSeatsForSelectedSession(): void {
    const sessionBlocks = this.blockedSeatsEvent.filter((bs: any) => bs.id_session == this.selectedSession);
    const globalBlocks = this.blockedSeatsEvent.filter((bs: any) => bs.id_session == null);
    this.blockedSeats = [...sessionBlocks, ...globalBlocks];
  }

  changeSession(): void {
    this.updateBlockedSeatsForSelectedSession();
  }

  getSessionDateString(session: any): string {
    if (!session?.start_date) {
      return 'Sesión sin fecha';
    }
    return formatDate(session.start_date, 'dd/MM/yyyy - HH:mm', 'es', '+0000') + 'h';
  }

  createMap() {
    this.openedCreateMap = !this.openedCreateMap;
    let action = !this.openedCreateMap ? 'close' : 'edit';
    this.eventService.setActionMap({ action: action });

    // const dialogRef = this.dialog.open(InfoCardComponent, {
    //   panelClass: 'info-dialog',
    //   data: {
    //     icon: true,
    //     text: 'Aún no puedes crear mapas de butacas, por favor, contacta con el administrador de Citylok para más información.',
    //     btnCancel: false
    //   }
    // });
  }

  changeMap() {
    // this.createService.setMapEvent(this.capacity);
  }

  changeCapacity() {
    // Al editar un evento existente, no permitir bajar el aforo por debajo de las
    // entradas ya vendidas (misma protección que tenía el editor antiguo).
    if (this.idEvent) {
      this.ordersEventService.getCountTickets(this.idEvent).subscribe({
        next: (val) => {
          if (this.capacity >= val.data.count) {
            this.createService.setCapacity(this.capacity);
          } else {
            this.capacity = val.data.count;
            this.createService.setCapacity(this.capacity);
            this.dialog.open(InfoCardComponent, {
              panelClass: 'info-dialog',
              data: {
                icon: false,
                text: 'No se puede poner un aforo menor que las entradas vendidas.',
                btnCancel: false
              }
            });
          }
        }
      });
      return;
    }
    this.createService.setCapacity(this.capacity);
  }

  nextStep() {
    let step = { tab: 5, name: '5. Configuración de venta', slug: 'sale-config-event' };
    this.changeTab.emit(step);
  }

  ngOnDestroy(): void {
    this.eventService.setActionMap({ open: false });
  }
}
